import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './session';
import Home from './Home';
import NotAdmin from './NotAdmin';
import SignIn from './SignIn';
import ReviewSpread from './ReviewSpread';
import BookPage from './BookPage';

// Auth decides what renders before routing does: there is exactly one place a signed-out or
// non-admin visitor can end up, and no route can be reached around it.
function Gate() {
  const auth = useAuth();

  if (auth.status === 'loading') return <main className="centered">Loading…</main>;
  if (auth.status === 'signed-out') return <SignIn />;
  if (auth.status === 'not-admin') return <NotAdmin email={auth.email} />;

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/book/:bookId/spread/:spreadId" element={<ReviewSpread />} />
      <Route path="/book/:bookId" element={<BookPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Gate />
      </BrowserRouter>
    </AuthProvider>
  );
}
